import Inputmask from 'inputmask';

const $dateOfBirth = $('#date-of-birth');

if ($dateOfBirth.length) {
    var im = new Inputmask('99/99/9999', { placeholder: gmtrans('shared.date_mask') });
    im.mask($dateOfBirth);
}
